<template>
    <v-flex>{{ fullName }}</v-flex>
</template>

<script>
/**
 * Outputs the reviewers full name based on their reviewer_key in hotel_visits
 *
 */
export default {
    name: 'ies-reviewer-name',
    props: ['field', 'value'],
    data () {
        return {
			fullName: '',
            allReviewers: []
		}
    },

    created(){
        this.loadReviewers();
    },

    methods: {
        loadReviewers(){
		    axios.get('/api/staff-users').then( (response) => {
                    this.allReviewers = response.data;
                    this.setReviewerName();
                });
        },

        setReviewerName(){
            console.log("HOTEL REVIWERS: set reviewr name");
		    if (this.value == 0) {
			    this.fullName = 'Other';
            } else {
                this.allReviewers.forEach( (reviewer) => {
				    if (reviewer.user_key == this.value) {
					    console.log( reviewer.first_name + ' ' + reviewer.surname);
    					this.fullName = reviewer.first_name + ' ' + reviewer.surname; 
	    			}
		    	});
            }
        }

    },

    watch: {
        field: function(newValue){
            console.log("HOTEL REVIEWERS: The field watch fired", newValue);
        },
        value: function(newValue){
            console.log("HOTEL REVIEWERS: The value watch fired", newValue);
            this.setReviewerName();
        }
    }
}
</script>


